import { SectionsGallery, SectionProps } from "@/types";

import { galleryVariant } from "./gallery.variants";

export type UseGalleryProps = SectionProps<SectionsGallery>;

export const useGallery = (props: UseGalleryProps) => {
  const { data, sectionName } = props;

  const styles = galleryVariant();

  return {
    styles,
    data,
    sectionName,
  };
};
